import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { uploadFile } from '@dealstack/frontend/shared/dataExchange/services/god.service';
import { useUploadFile } from '@dealstack/frontend/shared/components/DragAndDrop/useUploadFile';

import { useEffect, useState } from 'react';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { DataFileTct } from '@dealstack/shared/lib/generated/models/DataFileTct';

export const useFileUploadController = ({
	successCallback,
}: {
	successCallback: (files: DataFileTct[]) => void;
}) => {
	/**************VARS***************** */
	const uploadFileRequest = useWrappedRequest(uploadFile);
	const [isUploading, setIsUploading] = useState(false);
	const { isUploadSuccess } = useUploadFile({
		uploadFileRequest,
	});

	/**************LIFECYCLE***************** */

	useEffect(() => {
		if (!isUploadSuccess) {
			return;
		}
		if (!isUploading) {
			return;
		}
		showToastV2({
			title: 'success',
			message: 'Upload complete',
		});
	}, [isUploadSuccess]);

	/**************METHODS***************** */

	const onDropFiles = async (files) => {
		if (files.length === 0) {
			return;
		}
		setIsUploading(true);
		const buffer: DataFileTct[] = [];
		for (const file of files) {
			const formData = new FormData();
			formData.append('file', file);
			formData.append('fileSize', file.size.toString());
			formData.append('skipPdfProcessing', 'false');

			const response = await uploadFileRequest
				.fetch({
					formData,
				})
				.concludeWithPromise();
			if (response?.payload) {
				buffer.push(response.payload);
			}
		}

		successCallback(buffer);
		setIsUploading(false);
	};

	/**************RETURN***************** */

	return {
		onDropFiles,
	};
};
